import { type RouteRecordRaw } from 'vue-router'

export const domainsRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/DomainsRootView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
      title: 'website.domains',
    },
    name: 'brand.domains',
    path: 'domains',
  },
]
